mutation ImportMarketingContacts($input: ImportMarketingContactsInput!) {
  importMarketingContacts(input: $input) {
    added
    updated
    invalid
    duplicates
    matchedViewers
  }
}
